import axios, { AxiosError, AxiosResponse } from 'axios';
import { TrackingEvent } from './model/tracking.event';
import { AnalyticActionEvent, AnalyticEventType } from '../analytics';
import { TrackingData } from './model/tracking-data';

const url = '/hermes-service/topic/reviews_tracking_events';
const successCallback = (response: AxiosResponse) => {};
const errorCallback = (error: AxiosError) => {};

const headers = {
  Accept: 'application/json',
  type: 'application/json',
  'x-client': 'reviews-front'
};

export class TrackingService {
  sendEvent(trackingData: TrackingData, action: AnalyticActionEvent) {
    const tracking = this.buildTrackingEvent(trackingData, trackingData.product_type, action);
    if (tracking.action !== AnalyticActionEvent.PAGE_VIEW) this.sendEventThroughBeacon(tracking);
    else this.sendEventThroughHttp(tracking);
  }

  private sendEventThroughHttp(tracking: TrackingEvent) {
    axios
      .post(url, tracking)
      .then(successCallback)
      .catch(errorCallback);
  }

  private sendEventThroughBeacon(tracking: TrackingEvent) {
    if (window.navigator.sendBeacon) {
      window.navigator.sendBeacon(url, new Blob([JSON.stringify(tracking)], headers));
    } else {
      console.error('Beacon API is not available');
    }
  }

  private buildTrackingEvent(trackingData: TrackingData, label: string, action: AnalyticActionEvent) {
    return new TrackingEvent(action, AnalyticEventType.USER_ACTION, label, trackingData);
  }
}
